<template lang="pug">
cadastrante-sicarf(:cadastrante="cadastro.cadastrante" :isProcessoFisico="true")
</template>

<script>
import CadastranteSicarf from '../../../../components/cadastro/CadastranteSicarf'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['cadastro'],

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      findPessoa: 'pessoa/findByCpfOrCnpj'
    })
  },

  watch: {
    async cadastro (val) {
      if (!val?.cadastrante?.pessoa?.cpfCnpj) {
        this.cadastro.cadastrante.pessoa = await this.findPessoa(this.usuarioLogado.pessoa.pessoaFisica ? this.usuarioLogado.pessoa.pessoaFisica.cpf
          : this.usuarioLogado.pessoa.pessoaJuridica.cnpj)
      }
      this.cadastro.cadastrante.pessoa.telefones = this.cadastro.cadastrante.pessoa.telefones.map(item => item?.numero)
    }
  },

  components: {
    CadastranteSicarf
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/components/Cadastrante.vue